import { render, staticRenderFns } from "./ConceptProductDetail.vue?vue&type=template&id=2f2b7bed&"
import script from "./ConceptProductDetail.vue?vue&type=script&lang=js&"
export * from "./ConceptProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConceptProductDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports